<template>
  <div style="padding: 15px">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
    >
      <div class="titleh1">
        <code />基本信息
      </div>
      <el-row>
        <el-col
          :span="8"
          style="display: none"
        >
          <el-form-item label="用户编码">
            <el-input v-model="form.partyCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="商户名称"
            prop="merchantName"
          >
            <el-input
              v-model="form.merchantName"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="4"
          style="margin-left:10px;display:none"
        >
          <el-button
            type="primary"
            @click="selUser"
          >
            选择用户
          </el-button>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="商户类型"
            prop="merchantType"
          >
            <el-select
              v-model="form.merchantType"
              :disabled="statusdisabled"
              placeholder="请选择商户类型"
              @change="setAccountType"
            >
              <el-option
                label="自然人"
                value="01"
              />
              <el-option
                label="个体工商户"
                value="02"
              />
              <el-option
                label="企业商户"
                value="03"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1">
        <code />详细信息
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item prop="detail.certPhotoA">
            <ImgUpload
              :upload-config="{ lebal: '身份证国徽面照片', prefix: 'certPhotoA', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="detail.certPhotoB">
            <ImgUpload
              :upload-config="{ lebal: '身份证人像面照片', prefix: 'certPhotoB', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '03'"
          :span="8"
        >
          <el-form-item prop="detail.contractPhoto">
            <ImgUpload
              :upload-config="{ lebal: '租赁协议', prefix: 'contractPhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="8"
        >
          <el-form-item prop="detail.licensePhoto">
            <ImgUpload
              :upload-config="{ lebal: '营业执照图片', prefix: 'licensePhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="8"
        >
          <el-form-item prop="detail.shopPhoto">
            <ImgUpload
              :upload-config="{ lebal: '店铺门头照', prefix: 'shopPhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="8"
        >
          <el-form-item prop="detail.shopEntrancePhoto">
            <ImgUpload
              :upload-config="{ lebal: '门店内景照片', prefix: 'shopEntrancePhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType == '03'"
          :span="8"
        >
          <el-form-item prop="detail.industryLicensePhoto">
            <ImgUpload
              :upload-config="{ lebal: '开户许可证照片', prefix: 'industryLicensePhoto', form: form.detail, suffix: '', modal: false, isRequired: false }"
              :parent-data="parentData"
              :required="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="商户简称"
            prop="detail.alias"
          >
            <el-input
              v-model="form.detail.alias"
              clearable
              placeholder="请输入商户简称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="contactLableName+'姓名'"
            prop="detail.contactName"
          >
            <el-input
              v-model="form.detail.contactName"
              :disabled="statusdisabled"
              clearable
              :placeholder="'请输入'+contactLableName+'姓名'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="银行预留手机号"
            label-width="130px"
            prop="detail.contactMobile"
          >
            <el-input
              v-model="form.detail.contactMobile"
              clearable
              placeholder="请输入银行预留手机号"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="身份证号码"
            prop="detail.principalCertNo"
          >
            <el-input
              v-model="form.detail.principalCertNo"
              :disabled="statusdisabled"
              clearable
              placeholder="请输入身份证号码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="身份证有效期" prop="detail.personCertVld">
            <el-date-picker
              v-model="form.detail.personCertVld"
              :class="form.hasDueDate?'disabledhide':''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox v-model="form.hasDueDate" @change="(value)=>{this.$set(form.detail,'personCertVld' , value?'9999-12-31':'');}" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="省"
            prop="detail.province"
          >
            <el-select
              v-model="form.detail.province"
              clearable
              placeholder="请选择省"
              @change="cityChange(form.detail.province)"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.provinceCode"
                :label="item.provinceName"
                :value="item.provinceCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="市"
            prop="detail.city"
          >
            <el-select
              v-model="form.detail.city"
              clearable
              placeholder="请选择市"
              @change="districtChage(form.detail.city)"
            >
              <el-option
                v-for="item in cityList"
                :key="item.cityCode"
                :label="item.cityName"
                :value="item.cityCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="县/区"
            prop="detail.district"
          >
            <el-select
              v-model="form.detail.district"
              clearable
              placeholder="请选择区/县"
            >
              <el-option
                v-for="item in districtList"
                :key="item.countyCode"
                :label="item.countyName"
                :value="item.countyCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="14">
          <el-form-item
            label="详细地址"
            prop="detail.address"
          >
            <el-input
              v-model="form.detail.address"
              clearable
              placeholder="请输入详细地址"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.merchantType != '01'"
          :span="10"
        >
          <el-form-item
            label="信用代码"
            prop="detail.bussAuthNum"
          >
            <el-input
              v-model="form.detail.bussAuthNum"
              :disabled="statusdisabled"
              clearable
              placeholder="请输入统一社会信用代码"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="titleh1">
        <code />银行信息
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="账户类型"
            prop="card.accountType"
          >
            <el-select
              v-model="form.card.accountType"
              :disabled="statusdisabled"
              placeholder="请选择账户类型"
            >
              <el-option
                label="对私账户（自然人、个体工商户可选）"
                value="01"
              />
              <el-option
                label="对公账户（企业类型才可选填写）"
                value="02"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="银行卡号"
            prop="card.bankCardNo"
          >
            <el-input
              v-model="form.card.bankCardNo"
              clearable
              placeholder="请输入银行卡号"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.card.accountType == '02'"
          :span="8"
        >
          <el-form-item
            label="联行号"
            prop="card.contactLine"
          >
            <el-input
              v-model="form.card.contactLine"
              clearable
              placeholder="请输入联行号"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-button
        type="primary"
        @click="addClick('form')"
      >
        确定
      </el-button>
    </el-form>
    <vxe-modal
      v-model="vardel"
      width="800"
      height="80%"
      title="选择用户"
      resize
    >
      <Selectuser
        v-if="vardel"
        ref="ShipperlRef"
        @event1="receive"
      />
    </vxe-modal>
  </div>
</template>
<script>
  import {
    editBankMerchant,
    bigAreaProvince,
    bigAreaCity,
    bigAreaCounty,
    mybankMerchantDetails
  } from "@/api/InternetBanking";
  import ImgUpload from "@/components/ImgUpload";
  import Selectuser from "./components/Selectuser.vue";
  import {
    validatePhone,
    validateIDNumber,
  } from "@/utils/validate.js";
import { isBusinessLicenseImgNum, isBankCardNum } from '@/utils/validate4Form'
  export default {
    name: "MerchantManagementEdit",
    components: {
      ImgUpload,
      Selectuser
    },
    props: {
      parentData: {
        type: Object,
        default() {
          return {
            isDetail: false
          };
        }
      }
    },
    data() {
      return {
        statusdisabled: false,
        contactLableName: '联系人',
        vardel: false,
        provinceList: [],
        cityList: [],
        districtList: [],
        defaultForm:{},
        form: {
          merchantName: "",
          merchantType: "",
          detail: {
            alias: "",
            contactName: "",
            contactMobile: "",
            province: "",
            city: "",
            district: "",
            address: "",
            principalCertNo: "",
            certPhotoA: "",
            certPhotoB: "",
            contractPhoto: "",
            bussAuthNum: "",
            licensePhoto: "",
            shopPhoto: "",
            shopEntrancePhoto: "",
            industryLicensePhoto: "",
            personCertVld: ""
          },
          card: {
            bankCardNo: "",
            accountType: "",
            contactLine: ""
          }
        },
        rules: {
          merchantName: [
            {required: true, message: "请输入商户名称", trigger: "blur"},
            { min: 1, max: 50, message: '长度在 1 到 50 个字符' }
          ],
          merchantType: [
            {required: true, message: "请选择商户类型", trigger: "change"}
          ],
          detail: {
            certPhotoA: [
              {
                required: true,
                message: "请选择负责人身份证国徽面",
                trigger: "blur"
              }
            ],
            certPhotoB: [
              {
                required: true,
                message: "请选择负责人身份证人像面",
                trigger: "blur"
              }
            ],
            contractPhoto: [
              {required: true, message: "请选择租赁协议", trigger: "blur"}
            ],
            licensePhoto: [
              {required: true, message: "请选择营业执照", trigger: "blur"}
            ],
            shopPhoto: [
              {required: true, message: "请选择门头照片", trigger: "blur"}
            ],
            shopEntrancePhoto: [
              {required: true, message: "请选择店内时景照", trigger: "blur"}
            ],
            industryLicensePhoto: [
              {required: true, message: "请选择开户许可照", trigger: "blur"}
            ],
            alias: [
              {required: true, message: "请输入商户简称", trigger: "blur"},
              { min: 1, max: 50, message: '长度在 1 到 50 个字符'}
            ],
            contactName: [
              {
                required: true,
                validator(rule, value, callback) {
                  // eslint-disable-next-line
                  /^[\u4e00-\u9fa5\·]+$/.test(value)
                    ? callback()
                    : callback(new Error("请输入姓名(仅支持汉字)"));
                }
              }
            ],
            contactMobile: [
              {
                required: true,
                validator(rule, value, callback) {
                  validatePhone(value)
                    ? callback()
                    : callback(new Error("请输入正确的手机号"));
                }
              }
            ],
            province: [
              {required: true, message: "请选择省", trigger: "change"}
            ],
            city: [{required: true, message: "请选择市", trigger: "change"}],
            district: [
              {required: true, message: "请选择县区", trigger: "change"}
            ],
            address: [
              {required: true, message: "请输入详细地址", trigger: "blur"}
            ],
            principalCertNo: [
              {
                required: true,
                validator(rule, value, callback) {
                  validateIDNumber(value)
                    ? callback()
                    : callback(new Error("请输入正确的身份证号"));
                }
              }
            ],
            bussAuthNum: [
              {
                required: true,
                message: "请输入统一社会信用代码",
                trigger: "blur"
              },
              { validator: isBusinessLicenseImgNum }
            ],
            personCertVld: [
              {required: true, message: "请选择身份证有效期", trigger: "change"}
            ]
          },
          card: {
            bankCardNo: [
              {
                required: true,
                message: "请输入银行卡号",
                trigger: "blur"
              },
              { validator: isBankCardNum }
            ],
            accountType: [
              {required: true, message: "请选择账户类型", trigger: "change"}
            ],
            contactLine: [
              {required: true, message: "请输入联行号", trigger: "blur"},
              { min: 1, max: 50, message: '长度在 1 到 50 个字符' }
            ]
          }
        }
      };
    },
    created() {
      this.bigProvince();
      // 深拷贝数据
      this.defaultForm  = JSON.parse(JSON.stringify(this.form))
    },
    methods: {
      addClick(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            const rLoading = this.openLoading();
            editBankMerchant(this.form).then(response => {
              rLoading.close();
              this.$message({message: response.msg, type: "success"});
              this.$emit("event2");
            });
          } else {
            return false;
          }
        });
      },initArea(data){
        this.cityChange(data.detail.province);
        this.districtChage(data.detail.city);
      },
      //详情
      MerchantEditor(a) {
        const rLoading = this.openLoading();
        this.$refs.form.resetFields()
        this.form = JSON.parse(JSON.stringify(this.defaultForm))
        mybankMerchantDetails(a).then(response => {
          rLoading.close();
          this.form = response.data;
          this.$set(this.form, "hasDueDate", this.form.detail.personCertVld=='9999-12-31')
          this.form.detail = response.data.detail || {}
          this.form.card = response.data.card || {}
          this.initArea(this.form);
          if (this.form.status > 0 && this.form.status < 4 &&this.form.merchantId) {
            this.statusdisabled = true;
          } else {
            this.statusdisabled = false;
          }
          if(this.form.merchantType=='03'){
            this.contactLableName = '法人';
          }else{
            this.contactLableName = '联系人';
          }
        });
      },
      selUser() {
        this.vardel = true;
      },
      setAccountType(value){
        if(value=='03'){
          this.form.card.accountType = '02'
          this.contactLableName = '法人';
        }
        else{
          this.form.card.accountType = '01'
          this.contactLableName = '联系人';
        }
      },
      receive(data) {
        if(data.getdata.partyType == 'SHIPMENT_COMPANY'){
          this.form.merchantType = '03'
          this.form.card.accountType = '02'
        }
        else{
          this.form.merchantType = '01'
          this.form.card.accountType = '01'
        }
        this.form.merchantName = data.name;
        this.form.partyCode = data.code;
        this.vardel = false;
      },
      //省
      bigProvince() {
        bigAreaProvince().then(response => {
          this.provinceList = response.data.records;
        });
      },
      //市
      cityChange(a) {
        bigAreaCity({provinceCode: a}).then(response => {
          this.cityList = response.data.records;
        });
      },
      districtChage(b) {
        bigAreaCounty({cityCode: b}).then(response => {
          this.districtList = response.data.records;
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
  .titleh1 {
    line-height: 50px;
    border-bottom: 1px solid #e2e2e2;
    margin-bottom: 15px;

    code {
      width: 5px;
      height: 20px;
      background-color: #ff7f21;
      float: left;
      margin-right: 5px;
      margin-top: 13px;
    }
  }
</style>
